export const schedulingOfShipments = () => {
  return [
    { text: '     6. SCHEDULING OF SHIPMENTS', bold: true, style: 'p', },

    { text: '     Independent Contractor and Company recognize, acknowledge and understand that scheduling of TICA Services and determining whether to accept and transport a Shipment hereunder are' +
        ' matters within Independent Contractor’s sole discretion.', style: 'p', },
  ]
}